module.exports = __webpack_public_path__ + "img/report.14afe75c.svg";